const fetchYmmJson = async (fileName, signal) => {
  const cacheBuster = Date.now();
  const response = await fetch(`/cdn/shop/files/${fileName}?v=${cacheBuster}`, { signal });

  if (!response.ok) throw new Error(`YMM: failed to fetch ${fileName}`);

  return response.json();
};

const SVG_QUESTION = `<svg width="24" height="24" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M17.1494 10.8313C16.5765 8.92179 18.0064 7 20 7C21.9936 7 23.4235 8.92179 22.8506 10.8313L21.2873 16.0422C21.2171 16.2762 21.182 16.3932 21.128 16.4895C20.989 16.7371 20.7513 16.9139 20.4743 16.9759C20.3664 17 20.2443 17 20 17C19.7557 17 19.6336 17 19.5257 16.9759C19.2487 16.9139 19.011 16.7371 18.872 16.4895C18.818 16.3932 18.7829 16.2762 18.7127 16.0422L17.1494 10.8313Z" fill="#DE2A2A" stroke="#DE2A2A" stroke-width="2"/>
<circle cx="20" cy="22" r="2" fill="#DE2A2A" stroke="#DE2A2A" stroke-width="2"/>
<circle cx="18" cy="18" r="18" fill="black"/>
<circle cx="18" cy="26.25" r="1" fill="white" stroke="white"/>
<path d="M18 22.25V20.3582C18 19.0992 18.8056 17.9815 20 17.5833C21.1944 17.1852 22 16.0675 22 14.8085V14.1243C22 11.9846 20.2654 10.25 18.1257 10.25H18C15.7909 10.25 14 12.0409 14 14.25" stroke="white" stroke-width="2" stroke-linecap="round"/>
</svg>`;

const SVG_CHECK = `<svg width="24" height="24" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M17.1494 10.8313C16.5765 8.92179 18.0064 7 20 7C21.9936 7 23.4235 8.92179 22.8506 10.8313L21.2873 16.0422C21.2171 16.2762 21.182 16.3932 21.128 16.4895C20.989 16.7371 20.7513 16.9139 20.4743 16.9759C20.3664 17 20.2443 17 20 17C19.7557 17 19.6336 17 19.5257 16.9759C19.2487 16.9139 19.011 16.7371 18.872 16.4895C18.818 16.3932 18.7829 16.2762 18.7127 16.0422L17.1494 10.8313Z" fill="#DE2A2A" stroke="#DE2A2A" stroke-width="2"/>
<circle cx="20" cy="22" r="2" fill="#DE2A2A" stroke="#DE2A2A" stroke-width="2"/>
<circle cx="18" cy="18" r="18" fill="#008A00"/>
<path d="M15 16L18.2581 18.4436C18.6766 18.7574 19.2662 18.6957 19.6107 18.3021L26 11" stroke="white" stroke-width="2" stroke-linecap="round"/>
<path d="M27 18C27 19.8805 26.411 21.7137 25.3156 23.2423C24.2203 24.7709 22.6736 25.9179 20.893 26.5224C19.1123 27.1268 17.187 27.1583 15.3874 26.6125C13.5879 26.0666 12.0046 24.9707 10.8598 23.4789C9.71505 21.987 9.06635 20.174 9.00482 18.2945C8.94329 16.415 9.47203 14.5634 10.5168 12.9999C11.5615 11.4363 13.0698 10.2392 14.8297 9.57685C16.5897 8.91444 18.513 8.81996 20.3294 9.30667" stroke="white" stroke-width="2" stroke-linecap="round"/>
</svg>`;

const SVG_WARNING = `<svg width="24" height="24" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="18" cy="18" r="18" fill="#DE2A2A"/>
<path d="M15.1494 13.8313C14.5765 11.9218 16.0064 10 18 10C19.9936 10 21.4235 11.9218 20.8506 13.8313L19.2873 19.0422C19.2171 19.2762 19.182 19.3932 19.128 19.4895C18.989 19.7371 18.7513 19.9139 18.4743 19.9759C18.3664 20 18.2443 20 18 20C17.7557 20 17.6336 20 17.5257 19.9759C17.2487 19.9139 17.011 19.7371 16.872 19.4895C16.818 19.3932 16.7829 19.2762 16.7127 19.0422L15.1494 13.8313Z" stroke="white" stroke-width="2"/>
<circle cx="18" cy="25" r="2" stroke="white" stroke-width="2"/>
</svg>`;

const escapeHtml = (str) => str
  .replace(/&/g, '&amp;')
  .replace(/</g, '&lt;')
  .replace(/>/g, '&gt;')
  .replace(/"/g, '&quot;')
  .replace(/'/g, '&#x27;');

class YmmProduct {
  #makeAbort  = null;
  #modelAbort = null;

  constructor(container) {
    this.container     = container;
    this.collectionUrl = container.dataset.collectionUrl ?? '';
    this.form          = container.querySelector('.js-ymm-product-form');
    this.formContainer = container.querySelector('.js-ymm-product-container');
    this.overlay       = container.querySelector('.js-ymm-product-overlay');
    this.closeBtn      = container.querySelector('.js-ymm-product-close');
    this.vehicleBar    = container.querySelector('.js-ymm-vehicle');
    this.vehicleLabel  = container.querySelector('.js-ymm-vehicle-label');
    this.vehicleRemove = container.querySelector('.js-ymm-vehicle-remove');
    this.yearSelect    = container.querySelector('.js-ymm-year');
    this.makeSelect    = container.querySelector('.js-ymm-make');
    this.modelSelect   = container.querySelector('.js-ymm-model');
    this.filterBtn     = container.querySelector('.js-ymm-filter');
    this.clearBtn      = container.querySelector('.js-ymm-clear');

    this.#bindEvents();
    this.#populateYears();
    this.#renderVehicle();
  }

  #bindEvents() {
    this.closeBtn.addEventListener('click', () => this.#closeDrawer());
    this.overlay.addEventListener('click', () => this.#closeDrawer());
    this.vehicleRemove.addEventListener('click', () => this.#onVehicleRemove());
    this.yearSelect.addEventListener('change', () => this.#onYearChange());
    this.makeSelect.addEventListener('change', () => this.#onMakeChange());
    this.modelSelect.addEventListener('change', () => this.#updateFilterBtn());
    this.clearBtn.addEventListener('click', () => this.#onClear());
    this.form.addEventListener('submit', (e) => this.#onSubmit(e));
  }

  #renderVehicle() {
    const vehicle = localStorage.getItem('vehicle');

    if (vehicle) {
      const handle = localStorage.getItem('vehicle-cat');
      this.vehicleLabel.textContent = vehicle;
      this.vehicleLabel.href        = handle ? `/collections/${handle}` : '#';
      this.vehicleBar.style.display = 'block';
    } else {
      this.vehicleBar.style.display = 'none';
    }
  }

  #onVehicleRemove() {
    localStorage.removeItem('vehicle');
    localStorage.removeItem('vehicle-cat');
    this.vehicleBar.style.display = 'none';
    this.container.dispatchEvent(new CustomEvent('ymm:vehicle-changed', { bubbles: true }));
  }

  #closeDrawer() {
    this.formContainer.classList.remove('ymm-product__container--open');
    this.overlay.classList.remove('ymm-product__overlay--open');
    document.body.style.overflow = '';
  }

  async #populateYears() {
    this.yearSelect.disabled = true;

    try {
      const data = await fetchYmmJson('ymm_years.json');
      const placeholder = this.yearSelect.dataset.placeholder ?? '';
      this.yearSelect.innerHTML = `<option value="">${placeholder}</option>`;

      for (const { year } of data.years ?? []) {
        const opt = document.createElement('option');
        opt.value = year;
        opt.textContent = year;
        this.yearSelect.appendChild(opt);
      }
    } catch {
      // silently fail — year select stays empty
    }

    this.yearSelect.disabled = false;
  }

  async #onYearChange() {
    this.#makeAbort?.abort();
    this.#makeAbort = new AbortController();

    this.#reset(this.makeSelect);
    this.#reset(this.modelSelect);
    this.#updateFilterBtn();

    const year = this.yearSelect.value;
    if (!year) return;

    try {
      const data = await fetchYmmJson(`ymm_${year}.json`, this.#makeAbort.signal);
      const makes = data.make ?? [];

      this.#populate(this.makeSelect, makes, 'id', 'title');
      this.makeSelect.disabled = makes.length === 0;
    } catch (e) {
      if (e.name !== 'AbortError') this.#reset(this.makeSelect);
    }

    this.#updateFilterBtn();
  }

  async #onMakeChange() {
    this.#modelAbort?.abort();
    this.#modelAbort = new AbortController();

    this.#reset(this.modelSelect);
    this.#updateFilterBtn();

    const year   = this.yearSelect.value;
    const makeId = this.makeSelect.value;
    if (!year || !makeId) return;

    try {
      const data = await fetchYmmJson(`ymm_${year}_${makeId}.json`, this.#modelAbort.signal);
      const models = data.models ?? [];

      this.#populate(this.modelSelect, models, 'handle', 'title');
      this.modelSelect.disabled = models.length === 0;
    } catch (e) {
      if (e.name !== 'AbortError') this.#reset(this.modelSelect);
    }

    this.#updateFilterBtn();
  }

  #onSubmit(e) {
    e.preventDefault();

    const year       = this.yearSelect.value;
    const makeTitle  = this.makeSelect.selectedOptions[0]?.textContent ?? '';
    const handle     = this.modelSelect.value;
    const modelTitle = this.modelSelect.selectedOptions[0]?.textContent ?? '';

    if (!handle) return;

    const url     = `/collections/${handle}`;
    const vehicle = `${makeTitle} ${modelTitle} ${year}`;

    localStorage.setItem('vehicle', vehicle);
    localStorage.setItem('vehicle-cat', handle);

    this.#renderVehicle();

    const isProductPage = !!document.querySelector('.product-form');

    if (isProductPage) {
      this.container.dispatchEvent(new CustomEvent('ymm:vehicle-changed', { bubbles: true }));
      this.#closeDrawer();
    } else {
      window.location.href = url;
    }
  }

  #onClear() {
    if (!this.collectionUrl) return;
    window.location.href = this.collectionUrl;
  }

  #populate(selectEl, items, valueKey, labelKey) {
    const placeholder = selectEl.dataset.placeholder ?? '';
    selectEl.innerHTML = `<option value="">${placeholder}</option>`;

    for (const item of items) {
      const opt = document.createElement('option');
      opt.value = item[valueKey];
      opt.textContent = item[labelKey];
      selectEl.appendChild(opt);
    }
  }

  #reset(selectEl) {
    const placeholder = selectEl.dataset.placeholder ?? '';
    selectEl.innerHTML = `<option value="">${placeholder}</option>`;
    selectEl.value    = '';
    selectEl.disabled = true;
  }

  #updateFilterBtn() {
    const allSelected =
      this.yearSelect.value  !== '' &&
      this.makeSelect.value  !== '' &&
      this.modelSelect.value !== '';

    this.filterBtn.disabled = !allSelected;
  }
}

class YmmProductInfo {
  #container;
  #collections;
  #i18n;

  constructor(container) {
    this.#container   = container;
    this.#collections = this.#readCollections();
    this.#i18n        = this.#readI18n();
    this.#render();

    container.addEventListener('ymm:vehicle-changed', () => this.update());
  }

  update() {
    const existing = document.querySelector('.ymm-info');
    if (existing) existing.remove();
    this.#render();
  }

  #readCollections() {
    const scriptTag = this.#container.querySelector('.js-ymm-product-collections');
    if (!scriptTag) return [];

    try {
      return JSON.parse(scriptTag.textContent) ?? [];
    } catch {
      return [];
    }
  }

  #readI18n() {
    const scriptTag = this.#container.querySelector('.js-ymm-product-i18n');
    if (!scriptTag) return {};

    try {
      return JSON.parse(scriptTag.textContent) ?? {};
    } catch {
      return {};
    }
  }

  #render() {
    const productFormEl = document.querySelector('.product-form');
    if (!productFormEl) return;

    const vehicle    = localStorage.getItem('vehicle');
    const vehicleCat = localStorage.getItem('vehicle-cat');

    let html;

    if (!vehicle) {
      html = this.#renderUnknown();
    } else {
      const inCollection = vehicleCat !== null && this.#collections.includes(vehicleCat);
      html = inCollection ? this.#renderFit(vehicle) : this.#renderNoFit(vehicle);
    }

    const temp = document.createElement('div');
    temp.innerHTML = html;
    productFormEl.insertAdjacentElement('beforebegin', temp.firstElementChild);

    const infoEl        = productFormEl.previousElementSibling;
    const toggleBtn     = infoEl?.querySelector('.js-ymm-info-toggle');
    const formContainer = this.#container.querySelector('.js-ymm-product-container');
    const overlay       = this.#container.querySelector('.js-ymm-product-overlay');

    if (!toggleBtn || !formContainer || !overlay) return;

    toggleBtn.addEventListener('click', () => {
      formContainer.classList.add('ymm-product__container--open');
      overlay.classList.add('ymm-product__overlay--open');
      document.body.style.overflow = 'hidden';
    });
  }

  #renderUnknown() {
    return `
      <div class="ymm-info ymm-info--unknown">
        <div class="ymm-info__icon">${SVG_QUESTION}</div>
        <div class="ymm-info__body">
          <p class="ymm-info__title">${escapeHtml(this.#i18n.unknown_title ?? '')}</p>
          <button type="button" class="ymm-info__action js-ymm-info-toggle">${escapeHtml(this.#i18n.unknown_action ?? '')}</button>
        </div>
      </div>
    `;
  }

  #renderFit(vehicle) {
    return `
      <div class="ymm-info ymm-info--fit">
        <div class="ymm-info__icon">${SVG_CHECK}</div>
        <div class="ymm-info__body">
          <p class="ymm-info__title">${escapeHtml(this.#i18n.fit_title ?? '')}</p>
          <p class="ymm-info__vehicle">${escapeHtml(vehicle)}</p>
          <button type="button" class="ymm-info__action js-ymm-info-toggle">${escapeHtml(this.#i18n.change_selection ?? '')}</button>
        </div>
      </div>
    `;
  }

  #renderNoFit(vehicle) {
    return `
      <div class="ymm-info ymm-info--nofit">
        <div class="ymm-info__icon">${SVG_WARNING}</div>
        <div class="ymm-info__body">
          <p class="ymm-info__title">${escapeHtml(this.#i18n.nofit_title ?? '')}</p>
          <p class="ymm-info__vehicle">${escapeHtml(vehicle)}</p>
          <button type="button" class="ymm-info__action js-ymm-info-toggle">${escapeHtml(this.#i18n.change_selection ?? '')}</button>
        </div>
      </div>
    `;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  for (const el of document.querySelectorAll('.js-ymm-product')) {
    new YmmProduct(el);

    const hasYmmTag = el.dataset.hasYmm === 'true';
    if (hasYmmTag) {
      new YmmProductInfo(el);
    }
  }
});
